import React, { useState } from "react";
import Truck from "../images/Truck.webp";
import Bin from "../images/Bin.webp";
import Trolley from "../images/Trolley.webp";
import Box from "../images/Box.webp";
import room from "../images/room.webp";
import Location from "../images/Location.webp";
import { Row, Col, Card } from "react-bootstrap";
import Fade from "react-reveal/Fade";

const services = [
  {
    id: "local-movers",
    href: "/local-movers",
    image: Trolley,
    imageAlt: "Local movers",
    title: "Local Movers",
    description:
      "In addition to nationwide relocations, we provide local moving services in select Canadian markets. Our crews help with careful loading, safe transportation, and smooth delivery for apartments, condos, homes, and offices.",
  },
  {
    id: "long-distance-movers",
    href: "/long-distance-movers",
    image: Truck,
    imageAlt: "Long-distance moving truck",
    title: "Residential Long-Distance Moving",
    description:
      "Our experienced team helps homeowners and renters relocate anywhere across Canada with care and efficiency. From planning and packing to transportation and delivery, we keep long-distance moves organized and stress-free.",
  },
  {
    id: "office-moving",
    href: "/junk-removal",
    image: Bin,
    imageAlt: "Commercial moving service",
    title: "Commercial & Office Moving",
    description:
      "Businesses trust us to coordinate organized office relocations that minimize downtime and keep operations moving. We help plan the move, protect equipment, and support a practical transition into the new workspace.",
  },
  {
    id: "packing-unpacking",
    href: "/packaging-services",
    image: Box,
    imageAlt: "Packing and unpacking service",
    title: "Packing & Unpacking",
    description:
      "Protect your belongings with professional packing services using quality materials and proven techniques. Our team can help pack fragile items, label boxes, prepare furniture, and support unpacking after arrival.",
  },
  {
    id: "cross-country-moving",
    href: "/moving-supplier",
    image: Location,
    imageAlt: "Cross-country moving route",
    title: "Cross-Country Moving",
    description:
      "As trusted cross-country movers in Canada, we handle relocations between provinces and major cities with careful planning and professional execution. If you're searching for dependable cross-country moving companies in Canada, Go Move Canada is ready to help.",
  },
  {
    id: "storage-services",
    href: "/storage-services",
    image: room,
    imageAlt: "Storage services",
    title: "Storage Services",
    description:
      "Convenient storage options are available for customers who need extra flexibility before or after their move. We help coordinate secure storage support for household goods, business items, and moving transitions.",
  },
];

const descriptionStyle = {
  fontFamily: "Lato, sans-serif",
  lineHeight: "1.55",
  minHeight: "74px",
};

const collapsedDescriptionStyle = {
  ...descriptionStyle,
  display: "-webkit-box",
  overflow: "hidden",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 3,
};

const readToggleStyle = {
  background: "transparent",
  border: "none",
  color: "#FC4243",
  cursor: "pointer",
  display: "block",
  fontFamily: "Lato, sans-serif",
  fontWeight: "700",
  margin: "0 auto",
  padding: "0",
  textDecoration: "underline",
};

const ServicePage = () => {
  const [expandedServiceId, setExpandedServiceId] = useState(null);

  const toggleService = (serviceId) => {
    setExpandedServiceId((currentServiceId) =>
      currentServiceId === serviceId ? null : serviceId
    );
  };

  return (
    <div>
      <div className="ServiceBanner container-fluid">
        <div className="text-center pt-4">
          <Fade right>
            <h6 style={{ color: "#ffff", fontFamily: "Lato, sans-serif" }}>
              OUR SERVICE
            </h6>
          </Fade>
          <Fade left>
            <h2
              style={{
                color: "#ffff",
                fontFamily: "Lato, sans-serif",
                fontWeight: "700",
              }}
            >
              Comprehensive Moving Services
            </h2>
          </Fade>
        </div>

        <Row className="px-5 pt-5 justify-content-center">
          {services.slice(0, 3).map((service) => {
            const isExpanded = expandedServiceId === service.id;

            return (
              <Col md={4} key={service.id}>
                <Card
                  className="zoom"
                  style={{
                    width: "18rem",
                    margin: "auto",
                    marginBottom: "10px",
                    transition: "transform 0.3s",
                  }}
                >
                  <Card.Body>
                    <a href={service.href} style={{ textDecoration: "none" }}>
                      <Card.Title style={{ textAlign: "center" }}>
                        <img
                          src={service.image}
                          alt={service.imageAlt}
                          style={{ width: "50%" }}
                        />
                      </Card.Title>
                      <h4
                        className="mb-2 text-center"
                        style={{
                          color: "#000",
                          fontFamily: "Lato, sans-serif",
                          fontWeight: "600",
                        }}
                      >
                        {service.title}
                      </h4>
                    </a>
                    <Card.Text
                      className="text-center"
                      style={
                        isExpanded
                          ? descriptionStyle
                          : collapsedDescriptionStyle
                      }
                    >
                      {service.description}
                    </Card.Text>
                    <button
                      type="button"
                      onClick={() => toggleService(service.id)}
                      style={readToggleStyle}
                    >
                      {isExpanded ? "Read Less" : "Read More"}
                    </button>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>

        <Row className="px-5 py-5 justify-content-center">
          {services.slice(3).map((service) => {
            const isExpanded = expandedServiceId === service.id;

            return (
              <Col md={4} key={service.id}>
                <Card
                  className="zoom"
                  style={{
                    width: "18rem",
                    margin: "auto",
                    marginBottom: "10px",
                    transition: "transform 0.3s",
                  }}
                >
                  <Card.Body>
                    <a href={service.href} style={{ textDecoration: "none" }}>
                      <Card.Title style={{ textAlign: "center" }}>
                        <img
                          src={service.image}
                          alt={service.imageAlt}
                          style={{ width: "50%" }}
                        />
                      </Card.Title>
                      <h4
                        className="mb-2 text-center"
                        style={{
                          color: "#000",
                          fontFamily: "Lato, sans-serif",
                          fontWeight: "600",
                        }}
                      >
                        {service.title}
                      </h4>
                    </a>
                    <Card.Text
                      className="text-center"
                      style={
                        isExpanded
                          ? descriptionStyle
                          : collapsedDescriptionStyle
                      }
                    >
                      {service.description}
                    </Card.Text>
                    <button
                      type="button"
                      onClick={() => toggleService(service.id)}
                      style={readToggleStyle}
                    >
                      {isExpanded ? "Read Less" : "Read More"}
                    </button>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default ServicePage;
